export const SITE_HEADER_MODULE = {
  ACTION_TYPES: {
    switchClick: 'switchClick',
    searchClick: 'searchClick',
    settingsClick: 'settingsClick',
    buzzClick: 'buzzClick',
    mainLogoClick: 'mainLogoClick',
    liveSwitchClick: 'liveSwitchClick',
    onToggleSearch: 'onToggleSearch',
    onIconSearchClick: 'onIconSearchClick',
    onSearchGroupedResults: 'onSearchGroupedResults',
    bolaoClick: 'bolaoClick',
    onNavItemClick: 'onNavItemClick',
  },

  ANALYTICS: {
    BUZZ_URL_CHARACTERS: 50,

    ACTION_TYPES: {
      onSportTypeClick: 'onSportTypeClick',
      onMoreListDisplay: 'onMoreListDisplay',
      onMoreButtonClick: 'onMoreButtonClick'
    },

    CLICK_TYPE: {
      open: 1,
      close: 0
    }
  },

  EXPANDABLE_ITEMS: {
    dropdown: -1,
    min: 3,
    max: 7,
  },

  NO_SELECTED_TAB: -1,
  MY_SCORES_TAB_ID: 0,
  MAIN_HEADER_DESKTOP_HEIGHT : 64,
  MAIN_HEADER_MOBILE_HEIGHT : 80,
  MAIN_HEADER_DESKTOP_TABS_OFFSET: 500,
  AVERAGE_TAB_SIZE: 100,

  SETTINGS_ICON_SIZE: {
    desktop: 24,
    mobile: 20
  },

  SEARCH_ICON_SIZE: {
    desktop: 24,
    mobile: 20
  },

  SPORT_TYPES_NO: {
    mediumSportTypeBar: 8,
    largeSportTypeBar: 11,
  },

  TOP_HEADER_LABEL: {
    scores: 'scores',
    betting: 'betting',
    news: 'news',
    placeholder: 'placeholder'
  }
}

export const BUZZ_URL = {
  "ar": {
    url: 'https://www.365scores.com/ar/news/magazine/',
    showOnlyInFooter: false,
    id: 2121
  },
  "pt": {
    url: 'https://www.365scores.com/pt-br/news/magazine/',
    showOnlyInFooter: false,
    id: 2065
  },
  "pt-br": {
    url: 'https://www.365scores.com/pt-br/news/magazine/',
    showOnlyInFooter: false,
    id: 2065
  },
  "es": {
    url: 'https://www.365scores.com/es/news/',
    showOnlyInFooter: false,
    id: 2262
  },
  "es-mx": {
    url: 'https://www.365scores.com/es/news/',
    showOnlyInFooter: false,
    id: 2262
  },
  "en": {
    url: 'https://www.365scores.com/news/',
    showOnlyInFooter: true,
    id: 2260
  },
  "en-us": {
    url: 'https://www.365scores.com/news/',
    showOnlyInFooter: true,
    id: 2260
  },
  "en-uk": {
    url: 'https://www.365scores.com/news/',
    showOnlyInFooter: true,
    id: 2260
  }
}
